import React, {Component} from 'react';
import AdminHomeTableRowTestmonilas from './admin-home-table-testmonials-row';

class AdminHomeTableTestmonialsSlider extends Component{

    

    render(){

        return(
           <div className="tab-pane fade " id="testmonilas" role="tabpanel">
                 <div className="text-center">
                    <a className="admin-add-btn red-btn" href="#addnewtestmonialSliderModal" data-toggle="modal" >اضافة سلايدر</a>
                </div>
               <div className="users-table-admin">
               
                <table className="table users-table-admin table-responsive-md">
                        <thead>
                            <tr>   
                                <th>اسم العميل </th>
                                <th>منصب العميل </th>
                                <th>رأي العميل</th>
                                <th>صورة العميل</th>
                                <th>المهام</th>
                            </tr>
                        </thead>
                        <tbody>
                            <AdminHomeTableRowTestmonilas  clientName={"صالح الفوزان"} clientPosition={"المدير المالي"} clientFeedback={"رأي العميل مهم لنا"} clientImg={"Link"}/>
                            <AdminHomeTableRowTestmonilas  clientName={"صالح الفوزان"} clientPosition={"المدير المالي"} clientFeedback={"رأي العميل مهم لنا"} clientImg={"Link"}/>
                            <AdminHomeTableRowTestmonilas  clientName={"صالح الفوزان"} clientPosition={"المدير المالي"} clientFeedback={"رأي العميل مهم لنا"} clientImg={"Link"}/>
                            <AdminHomeTableRowTestmonilas  clientName={"صالح الفوزان"} clientPosition={"المدير المالي"} clientFeedback={"رأي العميل مهم لنا"} clientImg={"Link"}/>
                            <AdminHomeTableRowTestmonilas  clientName={"صالح الفوزان"} clientPosition={"المدير المالي"} clientFeedback={"رأي العميل مهم لنا"} clientImg={"Link"}/>
                        </tbody>
                    </table>
                </div>
            </div>
                        
            
        );
       
    }

};
export default AdminHomeTableTestmonialsSlider;


